import React, { useState, useEffect } from 'react';

function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  if (!visible) return null;

  return (
    <a href="#" id="back-to-top" className="progress" onClick={(e) => { e.preventDefault(); scrollTop(); }}>
      <i className="fas fa-arrow-up"></i>
    </a>
  );
}

export default BackToTop;
